"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalDialog = ModalDialog;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _grommet = require("grommet");
var _grommetIcons = require("grommet-icons");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ModalDialog(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    testId = _ref.testId;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Layer, {
    position: "center",
    responsive: true,
    modal: true,
    onEsc: onClose,
    onClickOutside: onClose,
    "data-testid": testId,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, {
      pad: "medium",
      overflow: "auto",
      children: [onClose && /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Button, {
        alignSelf: "end",
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommetIcons.Close, {}),
        onClick: onClose,
        "data-testid": "".concat(testId, "-close-button")
      }), children]
    })
  });
}
ModalDialog.propTypes = {
  /**
   * Children elements to append
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  /**
   * Function invoked on escape and Close Button
   */
  onClose: _propTypes["default"].func.isRequired,
  /**
   * data-testid, will be used for testing
   */
  testId: _propTypes["default"].string.isRequired
};